// src/constants.ts
var ERC721 = "ERC721";
var ERC1155 = "ERC1155";
var ERC20 = "ERC20";

export {
  ERC721,
  ERC1155,
  ERC20
};
//# sourceMappingURL=chunk-I6HXGZRD.mjs.map